
export enum UserLinkType {
  AlertAnswer = 0,
  MyProfile = 1,
  Expert = 2
}
